import { Modal } from "react-bootstrap";
import AxiosInstance from "../../utils/axiosInstance";
import { useEffect, useState } from "react";
import loaderImg from "../../assets/loader.svg";
import toast from "react-hot-toast";
import OptInModel from "./OptInModel";
// Import your new component here
import DeleteConfirmationModel from "./DeleteRecordMessageModel";
export default function SeeRecordsModel({
  open,
  handleClose,
  callId,
  ccnCallId,
  project_id,
  endPoint,
  type,
}) {
  const [optRecords, setOptRecords] = useState([]);
  const [loader, setloader] = useState(false);

  // Edit States
  const [showEditModel, setShowEditModel] = useState(false);
  const [editData, setEditData] = useState(null);

  // Delete States (Added missing states)
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);

  useEffect(() => {
    if (open) {
      getOptRecords();
    }
  }, [open, callId, ccnCallId, project_id]);

  const getOptRecords = () => {
    const queryParams = new URLSearchParams(
      type === "DOT"
        ? { proposal_id: callId, ccn_call_id: ccnCallId }
        : { project_id: project_id },
    );

    setloader(true);
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${endPoint}&${queryParams}`,
    )
      .then((response) => {
        setOptRecords(response.data?.data || []);
        setloader(false);
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message || "Failed to fetch records",
        );
        setloader(false);
      });
  };

  // Handle Edit Logic
  const handleEditClick = (data) => {
    setEditData(data);
    setShowEditModel(true);
  };

  // Handle Delete Logic
  const handleDeleteClick = (id) => {
    setIdToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_DELETE_OPTIN}`,
      { id: idToDelete },
    )
      .then((res) => {
        if (res.data?.statusCode === 200) {
          toast.success(res.data?.message || "Record deleted successfully");
          setShowDeleteModal(false);
          getOptRecords(); // Refresh the list
        } else {
          toast.error(res.data?.message || "Delete failed");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
        setShowDeleteModal(false);
      });
  };

  return (
    <>
      <Modal size="xl" show={open} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">OPT Reports</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-scroll">
          <div className="container">
            {!loader ? (
              <div className="row mb-3">
                {optRecords && optRecords.length > 0 ? (
                  optRecords.map((data, i) => (
                    <div className="col-md-12 mb-3" key={data.id || i}>
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <td
                              colSpan="2"
                              className="text-center fw-bold bg-light"
                            >
                              {data?.company_name || "-"}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2">
                              <strong>Contact:</strong> {data?.name || "-"}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Phone:</strong> {data?.phone || "-"}
                            </td>
                            <td>
                              <strong>Email:</strong> {data?.email || "-"}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2">
                              <strong>Disadvantaged Status:</strong>{" "}
                              {data?.disadvantage_status
                                ?.map((item) => item?.name)
                                .join(", ") || "None"}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2">
                              <strong>Services Offered:</strong>{" "}
                              {data?.services_offered || "-"}
                            </td>
                          </tr>
                          {data.isUpdate && (
                            <tr>
                              <td colSpan="2" className="text-end">
                                <button
                                  className="btn btn-sm btn-primary me-2"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i className="fa fa-edit"></i> Edit
                                </button>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => handleDeleteClick(data.id)}
                                >
                                  <i className="fa fa-trash"></i> Delete
                                </button>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-4">No Data Found.</div>
                )}
              </div>
            ) : (
              <div className="text-center py-5">
                <img src={loaderImg} alt="loading" width="50" />
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* 1. Added the actual Modal component for deletion */}
      <DeleteConfirmationModel
        open={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to remove this record? This action cannot be undone."
      />

      {/* 2. Edit Model */}
      {showEditModel && (
        <OptInModel
          key={editData?.id || "new-record"}
          open={showEditModel}
          editData={editData}
          callId={callId}
          ccnCallId={ccnCallId}
          project_id={project_id}
          handleClose={() => {
            setShowEditModel(false);
            setEditData(null);
          }}
          endPoint={process.env.REACT_APP_EDIT_OPTIN}
          handleAPIcall={() => {
            setShowEditModel(false);
            getOptRecords();
          }}
        />
      )}
    </>
  );
}
